import {IActivityMonitor} from "app/common/activity_monitor";
import * as moment from "moment";

export interface IUpdateFunction {
    update(): Promise<void>;
}

export class UpdateLoop {
    private isUpdateLoopEnabled = false;
    private isAppActive = false;
    private updateLoopToken?: NodeJS.Timeout;

    public constructor(
        activityMonitor: IActivityMonitor,
        private readonly updateFunction: IUpdateFunction,
        private readonly updateLoopDelay: moment.Duration,
    ) {
        activityMonitor.activityStarted.subscribe(() => this.onActivityStarted());
        activityMonitor.activityStopped.subscribe(() => this.onActivityStopped());
        this.isAppActive = activityMonitor.isActive;
    }

    public enableUpdateLoop(): void {
        this.isUpdateLoopEnabled = true;
        this.updateUpdateLoopState();
    }

    public disableUpdateLoop(): void {
        this.isUpdateLoopEnabled = false;
        this.updateUpdateLoopState();
    }

    public async updateImmediately(): Promise<void> {
        await this.updateFunction.update();
    }

    private onActivityStarted(): void {
        this.isAppActive = true;
        this.updateUpdateLoopState();
    }

    private onActivityStopped(): void {
        this.isAppActive = false;
        this.updateUpdateLoopState();
    }

    private updateUpdateLoopState(): void {
        const wantedState = this.isUpdateLoopEnabled && this.isAppActive;
        const currentState = this.updateLoopToken !== undefined;
        if (wantedState === currentState) {
            return;
        }
        if (wantedState) {
            this.startUpdateLoop();
        } else {
            this.stopUpdateLoop();
        }
    }

    private startUpdateLoop(): void {
        this.updateLoopToken =
            setInterval(() => void this.updateFunction.update(), this.updateLoopDelay.asMilliseconds());
        void this.updateImmediately();
    }

    private stopUpdateLoop(): void {
        clearInterval(this.updateLoopToken);
        this.updateLoopToken = undefined;
    }
}
